/**
 * Unified user-facing copy when subscription plans or IAP offers cannot be shown or completed.
 * Use for paywall, pricing, and native purchase flows — avoid technical or store-backend wording in UI.
 */
export const SUBSCRIPTION_OPTIONS_UNAVAILABLE_MESSAGE =
  "We couldn't load subscription options right now. Please try again in a moment.";
